<template>
  <div>
    <form class="sanitasForms" @submit.prevent>
      <button class="list-filter__button-back" @click="$emit('filterClose')">
        <dotcom-icon
          name="chevron-right"
          art="light"
          rotation="180"
          class="list-filter__back-icon"
        />
        {{ $t('detailAndFilterBack') }}
      </button>
      <h5 class="list-filter__title">{{ $t('filter') }}</h5>
      <div class="list-filter__container">
        <div
          v-for="(groupItem, groupIndex) in filters"
          :key="groupIndex"
          class="list-filter__group"
        >
          <div class="list-filter__group-title">
            {{ groupItem.groupName }}
          </div>
          <div
            v-for="(tagItem, tagIndex) in filters[groupIndex].tags"
            :key="tagIndex"
            class="list-filter__group-row"
          >
            <Checkbox
              v-if="
                tagItem.tagKey !== FREIEARZTWAHL &&
                tagItem.tagKey !== KOMFORTLEISTUNGEN
              "
              v-model="tags[tagItem.tagKey]"
              :text="tagItem.tagName"
              class="list-filter__tag"
            ></Checkbox>
            <div
              v-if="
                tagItem.tagKey === FREIEARZTWAHL ||
                tagItem.tagKey === KOMFORTLEISTUNGEN
              "
              class="list-filter__tag-check"
            >
              <dotcom-icon
                name="check"
                art="light"
                color="--c-primary-color-2"
              />
              <span class="list-filter__tag-text">{{ tagItem.tagName }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="list-filter__buttons">
        <button
          type="button"
          class="list-filter__button list-filter__buttons-reset"
          @click="$emit('filterReset')"
        >
          {{ $t('filterReset') }}
        </button>
        <sanitas-button
          full-width-in-xs
          primary
          class="list-filter__button-show-result"
          @click="$emit('filterClose')"
        >
          {{ resultsFoundMessage }}
        </sanitas-button>
      </div>
    </form>
  </div>
</template>
<script>
import { useI36n } from '@jota-one/i36n/src/index.vue2'

import Checkbox from '@/components/sanitas-components/Checkbox'
import SanitasButton from '@/components/sanitas-components/SanitasButton'
import DotcomIcon from '@/modules/icon/Icon'

const FREIEARZTWAHL = 'FREIEARZTWAHL'
const KOMFORTLEISTUNGEN = 'KOMFORTLEISTUNGEN'

export default {
  name: 'ListFilter',
  components: { Checkbox, DotcomIcon, SanitasButton },
  props: {
    filteredHospitals: {
      type: Array,
      required: true,
    },
    filters: {
      type: Array,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const { $label } = useI36n()

    return {
      $t: $label,
    }
  },
  data: function () {
    return {
      FREIEARZTWAHL,
      KOMFORTLEISTUNGEN,
      tags: this.value,
    }
  },
  computed: {
    resultsFoundMessage() {
      let numResults = this.filteredHospitals.length
      let message =
        numResults === 1 ? 'filterShowResultSingular' : 'filterShowResultPlural'
      return this.$t(message, { numResults })
    },
  },
  watch: {
    tags: function () {
      this.$emit('input', this.tags)
    },
  },
}
</script>
<style lang="postcss" scoped>
.list-filter__button {
  background: none;
  border: none;
  padding: 0;
  color: var(--c-primary-color-3);
  cursor: pointer;
}

.list-filter__button-back {
  background: none;
  border: none;
  padding: 0;
  color: var(--c-primary-neutral-1);
  cursor: pointer;
  font-size: 14px;
  letter-spacing: 0.2px;
  margin-bottom: var(--spacing-6);
}

.list-filter__back-icon {
  margin-right: var(--spacing-1);
}

.list-filter__buttons-reset {
  font-weight: bold;
  font-size: 14px;
}

.list-filter__button-show-result {
  margin: 0;

  /* Needed to be specific enough */

  &.sanitas-button {
    margin-top: 0;
  }
}

.list-filter__title {
  font-weight: bold;
  margin-bottom: var(--spacing-4);
  font-size: 14px;
}

.list-filter__container {
  display: flex;
  gap: var(--spacing-8);
  margin-bottom: var(--spacing-8);
  flex-direction: column;
}

.list-filter__buttons {
  display: flex;
  gap: var(--spacing-6) var(--spacing-4);
  flex-direction: column-reverse;
}

.list-filter__group {
  background-color: var(--c-primary-neutral-3);
  padding: var(--spacing-6) var(--spacing-4) 0 var(--spacing-4);
  flex: 1;
}

.list-filter__group-title {
  font-weight: bold;
  margin-bottom: var(--spacing-4);
  font-size: 14px;
}

.list-filter__group-row {
  display: flex;
}

.list-filter__tag {
  margin-bottom: var(--spacing-4);
  font-size: 14px;

  & >>> .checkbox__label {
    font-size: 14px;
  }
}

.list-filter__tag-check {
  margin-bottom: 18px;
  margin-left: var(--spacing-1);
  font-size: 14px;
}

.list-filter__tag-text {
  margin-left: 13px;
}

@media (--sm) {
  .list-filter__title {
    font-size: 16px;
  }

  .list-filter__group-title {
    font-size: 16px;
  }

  .list-filter__tag {
    font-size: 16px;

    & >>> .checkbox__label {
      font-size: 16px;
    }
  }

  .list-filter__tag-check {
    font-size: 16px;
  }

  .list-filter__tag-text {
    margin-left: 11px;
  }

  .list-filter__container {
    flex-direction: row;
    flex-wrap: wrap;
  }

  .list-filter__buttons {
    flex-direction: row;
    justify-content: flex-end;
  }
}
</style>
